/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateRebalancingPlanRequest } from '../models';
// @ts-ignore
import type { ListRebalancingPlansResponse } from '../models';
// @ts-ignore
import type { ListWorkloadsResponse } from '../models';
// @ts-ignore
import type { LongRunningOperation } from '../models';
// @ts-ignore
import type { RebalancingConstraints } from '../models';
// @ts-ignore
import type { RebalancingPlan } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * RebalancingAPIApi - axios parameter creator
 * @export
 */
export const RebalancingAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancels a rebalancing plan that is in progress.
         * @summary Cancels an in-progress rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPICancelRebalancingPlan: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPICancelRebalancingPlan', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPICancelRebalancingPlan', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rebalancingAPICancelRebalancingPlan', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-plans/{id}:cancel`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a rebalancing plan and optionally triggers its execution.  This will result in a Rebalancing CRD being created in the cluster via kentroller.
         * @summary Creates a rebalancing plan for the cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster to rebalance.
         * @param {CreateRebalancingPlanRequest} createRebalancingPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPICreateRebalancingPlan: async (organizationId: string, clusterId: string, createRebalancingPlanRequest: CreateRebalancingPlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPICreateRebalancingPlan', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPICreateRebalancingPlan', 'clusterId', clusterId)
            // verify required parameter 'createRebalancingPlanRequest' is not null or undefined
            assertParamExists('rebalancingAPICreateRebalancingPlan', 'createRebalancingPlanRequest', createRebalancingPlanRequest)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-plans`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRebalancingPlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes a generated rebalancing plan.
         * @summary Executes a generated rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to execute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIExecuteRebalancingPlan: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPIExecuteRebalancingPlan', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPIExecuteRebalancingPlan', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rebalancingAPIExecuteRebalancingPlan', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-plans/{id}:execute`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets rebalancing constraints for a cluster.  This helps the UI show what can/cannot be rebalanced before creating a plan.
         * @summary Gets rebalancing constraints for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [aggressiveModeConfigIgnoreLocalPersistentVolumes] Rebalance workloads that use local-path Persistent Volumes.  WARNING: THIS WILL RESULT IN DATA LOSS.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemJobPods] Pods spawned by Jobs or CronJobs will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, pods spawned by Jobs or CronJobs will be terminated if the Rebalancer picks a node that runs them.  As such, they are likely to lose their progress.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemRemovalDisabledPods] Pods that are marked with \&quot;removal disabled\&quot; will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods will be evicted and disrupted.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemPodsWithoutController] Pods that don\&#39;t have a controller (bare pods) will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods might not restart, since they have no controller to do it.
         * @param {boolean} [aggressiveModeConfigIgnoreInstanceCriteria] Ignore instance criteria constraints from node pools during rebalancing.  When true, removes requirements that constrain instance types by name patterns  (instance-category, instance-family, instance-generation, instance-size, instance-cpu, instance-memory).  This allows the rebalancer to select from a broader range of instance types.
         * @param {boolean} [aggressiveModeConfigAggressiveEviction] Use aggressive eviction of NodeClaims which could block rebalancing plan execution  When true, NodeClaims and pods on them will be forcefully deleted after a default or specified  time interval has passed
         * @param {string} [aggressiveModeConfigDrainTimeoutSeconds] drain_timeout_seconds specifies the maximum time allowed for draining nodes during aggressive eviction.  OPTIONAL: If not specified (0), nodes drain indefinitely (graceful drain).  When specified, valid range: 60-3600 seconds (1 minute to 1 hour).  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using plain int64 seconds for simpler REST API client usage. --)
         * @param {boolean} [aggressiveModeConfigIgnoreBlockingPdb] Ignore pods blocked by PodDisruptionBudgets with 0 disruptions allowed.  WARNING: May violate PDB guarantees during eviction.
         * @param {boolean} [aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets] Ignore NodePool disruption budgets that allow 0 disruptions.  When true, overrides zero-disruption NodePool budgets with the default 10% safety budget  so rebalancing can proceed.  WARNING: May violate NodePool disruption budget guarantees.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemRemovalDisabledNodes] Nodes that are marked with \&quot;removal disabled\&quot; or \&quot;do-not-disrupt\&quot; annotations/labels  will not prevent the Rebalancer from deleting them.  WARNING: When true, such nodes will be disrupted despite their protection annotations.
         * @param {boolean} [aggressiveModeConfigIgnoreConsolidatable] When true, bypasses the Karpenter Consolidatable condition check during node  candidate selection. Nodes that Karpenter has not yet marked as consolidatable  (e.g. the ConsolidateAfter time window has not elapsed) will still be considered  for rebalancing.  WARNING: May disrupt nodes before Karpenter\&#39;s own consolidation timing.
         * @param {string} [aggressiveModeConfigIgnoreBlockingPdbTimeout] ignore_blocking_pdb_timeout specifies how long to wait before force-deleting PDB-blocked pods.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
         * @param {string} [aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout] ignore_problem_removal_disabled_pods_timeout specifies how long to wait before force-deleting  pods marked karpenter.sh/do-not-disrupt&#x3D;true on nodes being drained by a rebalancing plan.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIGetRebalancingConstraints: async (organizationId: string, clusterId: string, aggressiveModeConfigIgnoreLocalPersistentVolumes?: boolean, aggressiveModeConfigIgnoreProblemJobPods?: boolean, aggressiveModeConfigIgnoreProblemRemovalDisabledPods?: boolean, aggressiveModeConfigIgnoreProblemPodsWithoutController?: boolean, aggressiveModeConfigIgnoreInstanceCriteria?: boolean, aggressiveModeConfigAggressiveEviction?: boolean, aggressiveModeConfigDrainTimeoutSeconds?: string, aggressiveModeConfigIgnoreBlockingPdb?: boolean, aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets?: boolean, aggressiveModeConfigIgnoreProblemRemovalDisabledNodes?: boolean, aggressiveModeConfigIgnoreConsolidatable?: boolean, aggressiveModeConfigIgnoreBlockingPdbTimeout?: string, aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPIGetRebalancingConstraints', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPIGetRebalancingConstraints', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-constraints`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (aggressiveModeConfigIgnoreLocalPersistentVolumes !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreLocalPersistentVolumes'] = aggressiveModeConfigIgnoreLocalPersistentVolumes;
            }

            if (aggressiveModeConfigIgnoreProblemJobPods !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreProblemJobPods'] = aggressiveModeConfigIgnoreProblemJobPods;
            }

            if (aggressiveModeConfigIgnoreProblemRemovalDisabledPods !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreProblemRemovalDisabledPods'] = aggressiveModeConfigIgnoreProblemRemovalDisabledPods;
            }

            if (aggressiveModeConfigIgnoreProblemPodsWithoutController !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreProblemPodsWithoutController'] = aggressiveModeConfigIgnoreProblemPodsWithoutController;
            }

            if (aggressiveModeConfigIgnoreInstanceCriteria !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreInstanceCriteria'] = aggressiveModeConfigIgnoreInstanceCriteria;
            }

            if (aggressiveModeConfigAggressiveEviction !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.aggressiveEviction'] = aggressiveModeConfigAggressiveEviction;
            }

            if (aggressiveModeConfigDrainTimeoutSeconds !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.drainTimeoutSeconds'] = aggressiveModeConfigDrainTimeoutSeconds;
            }

            if (aggressiveModeConfigIgnoreBlockingPdb !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreBlockingPdb'] = aggressiveModeConfigIgnoreBlockingPdb;
            }

            if (aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreZeroNodePoolDisruptionBudgets'] = aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets;
            }

            if (aggressiveModeConfigIgnoreProblemRemovalDisabledNodes !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreProblemRemovalDisabledNodes'] = aggressiveModeConfigIgnoreProblemRemovalDisabledNodes;
            }

            if (aggressiveModeConfigIgnoreConsolidatable !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreConsolidatable'] = aggressiveModeConfigIgnoreConsolidatable;
            }

            if (aggressiveModeConfigIgnoreBlockingPdbTimeout !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreBlockingPdbTimeout'] = aggressiveModeConfigIgnoreBlockingPdbTimeout;
            }

            if (aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout !== undefined) {
                localVarQueryParameter['aggressiveModeConfig.ignoreProblemRemovalDisabledPodsTimeout'] = aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a rebalancing plan by ID.
         * @summary Gets a rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIGetRebalancingPlan: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPIGetRebalancingPlan', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPIGetRebalancingPlan', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rebalancingAPIGetRebalancingPlan', 'id', id)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-plans/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists rebalancing plans for a cluster.
         * @summary Lists rebalancing plans for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<RebalancingAPIListRebalancingPlansStatusFilterEnum>} [statusFilter] Filter plans by status (optional).  If empty, all statuses are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIListRebalancingPlans: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, statusFilter?: Array<RebalancingAPIListRebalancingPlansStatusFilterEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPIListRebalancingPlans', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPIListRebalancingPlans', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/rebalancing-plans`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (statusFilter) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists workloads in a cluster with their rebalancing status and cost impact.
         * @summary Lists workloads with rebalancing status.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIListWorkloads: async (organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('rebalancingAPIListWorkloads', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('rebalancingAPIListWorkloads', 'clusterId', clusterId)
            const localVarPath = `/kent/v1alpha/organizations/{organizationId}/clusters/{clusterId}/workloads`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RebalancingAPIApi - functional programming interface
 * @export
 */
export const RebalancingAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RebalancingAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancels a rebalancing plan that is in progress.
         * @summary Cancels an in-progress rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPICancelRebalancingPlan(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRunningOperation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPICancelRebalancingPlan(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPICancelRebalancingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a rebalancing plan and optionally triggers its execution.  This will result in a Rebalancing CRD being created in the cluster via kentroller.
         * @summary Creates a rebalancing plan for the cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster to rebalance.
         * @param {CreateRebalancingPlanRequest} createRebalancingPlanRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPICreateRebalancingPlan(organizationId: string, clusterId: string, createRebalancingPlanRequest: CreateRebalancingPlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRunningOperation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPICreateRebalancingPlan(organizationId, clusterId, createRebalancingPlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPICreateRebalancingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Executes a generated rebalancing plan.
         * @summary Executes a generated rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to execute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPIExecuteRebalancingPlan(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPIExecuteRebalancingPlan(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPIExecuteRebalancingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets rebalancing constraints for a cluster.  This helps the UI show what can/cannot be rebalanced before creating a plan.
         * @summary Gets rebalancing constraints for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {boolean} [aggressiveModeConfigIgnoreLocalPersistentVolumes] Rebalance workloads that use local-path Persistent Volumes.  WARNING: THIS WILL RESULT IN DATA LOSS.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemJobPods] Pods spawned by Jobs or CronJobs will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, pods spawned by Jobs or CronJobs will be terminated if the Rebalancer picks a node that runs them.  As such, they are likely to lose their progress.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemRemovalDisabledPods] Pods that are marked with \&quot;removal disabled\&quot; will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods will be evicted and disrupted.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemPodsWithoutController] Pods that don\&#39;t have a controller (bare pods) will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods might not restart, since they have no controller to do it.
         * @param {boolean} [aggressiveModeConfigIgnoreInstanceCriteria] Ignore instance criteria constraints from node pools during rebalancing.  When true, removes requirements that constrain instance types by name patterns  (instance-category, instance-family, instance-generation, instance-size, instance-cpu, instance-memory).  This allows the rebalancer to select from a broader range of instance types.
         * @param {boolean} [aggressiveModeConfigAggressiveEviction] Use aggressive eviction of NodeClaims which could block rebalancing plan execution  When true, NodeClaims and pods on them will be forcefully deleted after a default or specified  time interval has passed
         * @param {string} [aggressiveModeConfigDrainTimeoutSeconds] drain_timeout_seconds specifies the maximum time allowed for draining nodes during aggressive eviction.  OPTIONAL: If not specified (0), nodes drain indefinitely (graceful drain).  When specified, valid range: 60-3600 seconds (1 minute to 1 hour).  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using plain int64 seconds for simpler REST API client usage. --)
         * @param {boolean} [aggressiveModeConfigIgnoreBlockingPdb] Ignore pods blocked by PodDisruptionBudgets with 0 disruptions allowed.  WARNING: May violate PDB guarantees during eviction.
         * @param {boolean} [aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets] Ignore NodePool disruption budgets that allow 0 disruptions.  When true, overrides zero-disruption NodePool budgets with the default 10% safety budget  so rebalancing can proceed.  WARNING: May violate NodePool disruption budget guarantees.
         * @param {boolean} [aggressiveModeConfigIgnoreProblemRemovalDisabledNodes] Nodes that are marked with \&quot;removal disabled\&quot; or \&quot;do-not-disrupt\&quot; annotations/labels  will not prevent the Rebalancer from deleting them.  WARNING: When true, such nodes will be disrupted despite their protection annotations.
         * @param {boolean} [aggressiveModeConfigIgnoreConsolidatable] When true, bypasses the Karpenter Consolidatable condition check during node  candidate selection. Nodes that Karpenter has not yet marked as consolidatable  (e.g. the ConsolidateAfter time window has not elapsed) will still be considered  for rebalancing.  WARNING: May disrupt nodes before Karpenter\&#39;s own consolidation timing.
         * @param {string} [aggressiveModeConfigIgnoreBlockingPdbTimeout] ignore_blocking_pdb_timeout specifies how long to wait before force-deleting PDB-blocked pods.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
         * @param {string} [aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout] ignore_problem_removal_disabled_pods_timeout specifies how long to wait before force-deleting  pods marked karpenter.sh/do-not-disrupt&#x3D;true on nodes being drained by a rebalancing plan.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPIGetRebalancingConstraints(organizationId: string, clusterId: string, aggressiveModeConfigIgnoreLocalPersistentVolumes?: boolean, aggressiveModeConfigIgnoreProblemJobPods?: boolean, aggressiveModeConfigIgnoreProblemRemovalDisabledPods?: boolean, aggressiveModeConfigIgnoreProblemPodsWithoutController?: boolean, aggressiveModeConfigIgnoreInstanceCriteria?: boolean, aggressiveModeConfigAggressiveEviction?: boolean, aggressiveModeConfigDrainTimeoutSeconds?: string, aggressiveModeConfigIgnoreBlockingPdb?: boolean, aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets?: boolean, aggressiveModeConfigIgnoreProblemRemovalDisabledNodes?: boolean, aggressiveModeConfigIgnoreConsolidatable?: boolean, aggressiveModeConfigIgnoreBlockingPdbTimeout?: string, aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingConstraints>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPIGetRebalancingConstraints(organizationId, clusterId, aggressiveModeConfigIgnoreLocalPersistentVolumes, aggressiveModeConfigIgnoreProblemJobPods, aggressiveModeConfigIgnoreProblemRemovalDisabledPods, aggressiveModeConfigIgnoreProblemPodsWithoutController, aggressiveModeConfigIgnoreInstanceCriteria, aggressiveModeConfigAggressiveEviction, aggressiveModeConfigDrainTimeoutSeconds, aggressiveModeConfigIgnoreBlockingPdb, aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets, aggressiveModeConfigIgnoreProblemRemovalDisabledNodes, aggressiveModeConfigIgnoreConsolidatable, aggressiveModeConfigIgnoreBlockingPdbTimeout, aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPIGetRebalancingConstraints']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a rebalancing plan by ID.
         * @summary Gets a rebalancing plan.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the rebalancing plan to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPIGetRebalancingPlan(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RebalancingPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPIGetRebalancingPlan(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPIGetRebalancingPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists rebalancing plans for a cluster.
         * @summary Lists rebalancing plans for a cluster.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<RebalancingAPIListRebalancingPlansStatusFilterEnum>} [statusFilter] Filter plans by status (optional).  If empty, all statuses are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPIListRebalancingPlans(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, statusFilter?: Array<RebalancingAPIListRebalancingPlansStatusFilterEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListRebalancingPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPIListRebalancingPlans(organizationId, clusterId, pageLimit, pageCursor, statusFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPIListRebalancingPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists workloads in a cluster with their rebalancing status and cost impact.
         * @summary Lists workloads with rebalancing status.
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rebalancingAPIListWorkloads(organizationId: string, clusterId: string, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListWorkloadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rebalancingAPIListWorkloads(organizationId, clusterId, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RebalancingAPIApi.rebalancingAPIListWorkloads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RebalancingAPIApi - factory interface
 * @export
 */
export const RebalancingAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RebalancingAPIApiFp(configuration)
    return {
        /**
         * Cancels a rebalancing plan that is in progress.
         * @summary Cancels an in-progress rebalancing plan.
         * @param {RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPICancelRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<LongRunningOperation> {
            return localVarFp.rebalancingAPICancelRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a rebalancing plan and optionally triggers its execution.  This will result in a Rebalancing CRD being created in the cluster via kentroller.
         * @summary Creates a rebalancing plan for the cluster.
         * @param {RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPICreateRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<LongRunningOperation> {
            return localVarFp.rebalancingAPICreateRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.createRebalancingPlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Executes a generated rebalancing plan.
         * @summary Executes a generated rebalancing plan.
         * @param {RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIExecuteRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingPlan> {
            return localVarFp.rebalancingAPIExecuteRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets rebalancing constraints for a cluster.  This helps the UI show what can/cannot be rebalanced before creating a plan.
         * @summary Gets rebalancing constraints for a cluster.
         * @param {RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIGetRebalancingConstraints(requestParameters: RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingConstraints> {
            return localVarFp.rebalancingAPIGetRebalancingConstraints(requestParameters.organizationId, requestParameters.clusterId, requestParameters.aggressiveModeConfigIgnoreLocalPersistentVolumes, requestParameters.aggressiveModeConfigIgnoreProblemJobPods, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledPods, requestParameters.aggressiveModeConfigIgnoreProblemPodsWithoutController, requestParameters.aggressiveModeConfigIgnoreInstanceCriteria, requestParameters.aggressiveModeConfigAggressiveEviction, requestParameters.aggressiveModeConfigDrainTimeoutSeconds, requestParameters.aggressiveModeConfigIgnoreBlockingPdb, requestParameters.aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledNodes, requestParameters.aggressiveModeConfigIgnoreConsolidatable, requestParameters.aggressiveModeConfigIgnoreBlockingPdbTimeout, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a rebalancing plan by ID.
         * @summary Gets a rebalancing plan.
         * @param {RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIGetRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<RebalancingPlan> {
            return localVarFp.rebalancingAPIGetRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists rebalancing plans for a cluster.
         * @summary Lists rebalancing plans for a cluster.
         * @param {RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIListRebalancingPlans(requestParameters: RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListRebalancingPlansResponse> {
            return localVarFp.rebalancingAPIListRebalancingPlans(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.statusFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists workloads in a cluster with their rebalancing status and cost impact.
         * @summary Lists workloads with rebalancing status.
         * @param {RebalancingAPIApiRebalancingAPIListWorkloadsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rebalancingAPIListWorkloads(requestParameters: RebalancingAPIApiRebalancingAPIListWorkloadsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListWorkloadsResponse> {
            return localVarFp.rebalancingAPIListWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rebalancingAPICancelRebalancingPlan operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest
 */
export interface RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPICancelRebalancingPlan
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPICancelRebalancingPlan
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing plan to cancel.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPICancelRebalancingPlan
     */
    readonly id: string
}

/**
 * Request parameters for rebalancingAPICreateRebalancingPlan operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest
 */
export interface RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPICreateRebalancingPlan
     */
    readonly organizationId: string

    /**
     * The ID of the cluster to rebalance.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPICreateRebalancingPlan
     */
    readonly clusterId: string

    /**
     * 
     * @type {CreateRebalancingPlanRequest}
     * @memberof RebalancingAPIApiRebalancingAPICreateRebalancingPlan
     */
    readonly createRebalancingPlanRequest: CreateRebalancingPlanRequest
}

/**
 * Request parameters for rebalancingAPIExecuteRebalancingPlan operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest
 */
export interface RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIExecuteRebalancingPlan
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIExecuteRebalancingPlan
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing plan to execute.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIExecuteRebalancingPlan
     */
    readonly id: string
}

/**
 * Request parameters for rebalancingAPIGetRebalancingConstraints operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest
 */
export interface RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly clusterId: string

    /**
     * Rebalance workloads that use local-path Persistent Volumes.  WARNING: THIS WILL RESULT IN DATA LOSS.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreLocalPersistentVolumes?: boolean

    /**
     * Pods spawned by Jobs or CronJobs will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, pods spawned by Jobs or CronJobs will be terminated if the Rebalancer picks a node that runs them.  As such, they are likely to lose their progress.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreProblemJobPods?: boolean

    /**
     * Pods that are marked with \&quot;removal disabled\&quot; will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods will be evicted and disrupted.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreProblemRemovalDisabledPods?: boolean

    /**
     * Pods that don\&#39;t have a controller (bare pods) will not prevent the Rebalancer from deleting a node on which they run.  WARNING: When true, such pods might not restart, since they have no controller to do it.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreProblemPodsWithoutController?: boolean

    /**
     * Ignore instance criteria constraints from node pools during rebalancing.  When true, removes requirements that constrain instance types by name patterns  (instance-category, instance-family, instance-generation, instance-size, instance-cpu, instance-memory).  This allows the rebalancer to select from a broader range of instance types.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreInstanceCriteria?: boolean

    /**
     * Use aggressive eviction of NodeClaims which could block rebalancing plan execution  When true, NodeClaims and pods on them will be forcefully deleted after a default or specified  time interval has passed
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigAggressiveEviction?: boolean

    /**
     * drain_timeout_seconds specifies the maximum time allowed for draining nodes during aggressive eviction.  OPTIONAL: If not specified (0), nodes drain indefinitely (graceful drain).  When specified, valid range: 60-3600 seconds (1 minute to 1 hour).  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using plain int64 seconds for simpler REST API client usage. --)
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigDrainTimeoutSeconds?: string

    /**
     * Ignore pods blocked by PodDisruptionBudgets with 0 disruptions allowed.  WARNING: May violate PDB guarantees during eviction.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreBlockingPdb?: boolean

    /**
     * Ignore NodePool disruption budgets that allow 0 disruptions.  When true, overrides zero-disruption NodePool budgets with the default 10% safety budget  so rebalancing can proceed.  WARNING: May violate NodePool disruption budget guarantees.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets?: boolean

    /**
     * Nodes that are marked with \&quot;removal disabled\&quot; or \&quot;do-not-disrupt\&quot; annotations/labels  will not prevent the Rebalancer from deleting them.  WARNING: When true, such nodes will be disrupted despite their protection annotations.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreProblemRemovalDisabledNodes?: boolean

    /**
     * When true, bypasses the Karpenter Consolidatable condition check during node  candidate selection. Nodes that Karpenter has not yet marked as consolidatable  (e.g. the ConsolidateAfter time window has not elapsed) will still be considered  for rebalancing.  WARNING: May disrupt nodes before Karpenter\&#39;s own consolidation timing.
     * @type {boolean}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreConsolidatable?: boolean

    /**
     * ignore_blocking_pdb_timeout specifies how long to wait before force-deleting PDB-blocked pods.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreBlockingPdbTimeout?: string

    /**
     * ignore_problem_removal_disabled_pods_timeout specifies how long to wait before force-deleting  pods marked karpenter.sh/do-not-disrupt&#x3D;true on nodes being drained by a rebalancing plan.  OPTIONAL: If not specified, defaults to 10m. When specified, must be a positive duration.  (-- api-linter: core::0142::time-field-type&#x3D;disabled      aip.dev/not-precedent: Using google.protobuf.Duration for consistency with kentroller proto. --)
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingConstraints
     */
    readonly aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout?: string
}

/**
 * Request parameters for rebalancingAPIGetRebalancingPlan operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest
 */
export interface RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingPlan
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingPlan
     */
    readonly clusterId: string

    /**
     * The ID of the rebalancing plan to retrieve.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIGetRebalancingPlan
     */
    readonly id: string
}

/**
 * Request parameters for rebalancingAPIListRebalancingPlans operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest
 */
export interface RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListRebalancingPlans
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListRebalancingPlans
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListRebalancingPlans
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListRebalancingPlans
     */
    readonly pageCursor?: string

    /**
     * Filter plans by status (optional).  If empty, all statuses are returned.
     * @type {Array<'REBALANCING_PLAN_STATUS_UNSPECIFIED' | 'GENERATING' | 'READY' | 'EXECUTING' | 'COMPLETED' | 'FAILED' | 'CANCELED' | 'PARTIALLY_COMPLETED' | 'STALE' | 'SKIPPED' | 'EXPIRED'>}
     * @memberof RebalancingAPIApiRebalancingAPIListRebalancingPlans
     */
    readonly statusFilter?: Array<RebalancingAPIListRebalancingPlansStatusFilterEnum>
}

/**
 * Request parameters for rebalancingAPIListWorkloads operation in RebalancingAPIApi.
 * @export
 * @interface RebalancingAPIApiRebalancingAPIListWorkloadsRequest
 */
export interface RebalancingAPIApiRebalancingAPIListWorkloadsRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListWorkloads
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListWorkloads
     */
    readonly clusterId: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListWorkloads
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof RebalancingAPIApiRebalancingAPIListWorkloads
     */
    readonly pageCursor?: string
}

/**
 * RebalancingAPIApi - object-oriented interface
 * @export
 * @class RebalancingAPIApi
 * @extends {BaseAPI}
 */
export class RebalancingAPIApi extends BaseAPI {
    /**
     * Cancels a rebalancing plan that is in progress.
     * @summary Cancels an in-progress rebalancing plan.
     * @param {RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPICancelRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPICancelRebalancingPlanRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPICancelRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a rebalancing plan and optionally triggers its execution.  This will result in a Rebalancing CRD being created in the cluster via kentroller.
     * @summary Creates a rebalancing plan for the cluster.
     * @param {RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPICreateRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPICreateRebalancingPlanRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPICreateRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.createRebalancingPlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes a generated rebalancing plan.
     * @summary Executes a generated rebalancing plan.
     * @param {RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPIExecuteRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPIExecuteRebalancingPlanRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPIExecuteRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets rebalancing constraints for a cluster.  This helps the UI show what can/cannot be rebalanced before creating a plan.
     * @summary Gets rebalancing constraints for a cluster.
     * @param {RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPIGetRebalancingConstraints(requestParameters: RebalancingAPIApiRebalancingAPIGetRebalancingConstraintsRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPIGetRebalancingConstraints(requestParameters.organizationId, requestParameters.clusterId, requestParameters.aggressiveModeConfigIgnoreLocalPersistentVolumes, requestParameters.aggressiveModeConfigIgnoreProblemJobPods, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledPods, requestParameters.aggressiveModeConfigIgnoreProblemPodsWithoutController, requestParameters.aggressiveModeConfigIgnoreInstanceCriteria, requestParameters.aggressiveModeConfigAggressiveEviction, requestParameters.aggressiveModeConfigDrainTimeoutSeconds, requestParameters.aggressiveModeConfigIgnoreBlockingPdb, requestParameters.aggressiveModeConfigIgnoreZeroNodePoolDisruptionBudgets, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledNodes, requestParameters.aggressiveModeConfigIgnoreConsolidatable, requestParameters.aggressiveModeConfigIgnoreBlockingPdbTimeout, requestParameters.aggressiveModeConfigIgnoreProblemRemovalDisabledPodsTimeout, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a rebalancing plan by ID.
     * @summary Gets a rebalancing plan.
     * @param {RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPIGetRebalancingPlan(requestParameters: RebalancingAPIApiRebalancingAPIGetRebalancingPlanRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPIGetRebalancingPlan(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists rebalancing plans for a cluster.
     * @summary Lists rebalancing plans for a cluster.
     * @param {RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPIListRebalancingPlans(requestParameters: RebalancingAPIApiRebalancingAPIListRebalancingPlansRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPIListRebalancingPlans(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.statusFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists workloads in a cluster with their rebalancing status and cost impact.
     * @summary Lists workloads with rebalancing status.
     * @param {RebalancingAPIApiRebalancingAPIListWorkloadsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RebalancingAPIApi
     */
    public rebalancingAPIListWorkloads(requestParameters: RebalancingAPIApiRebalancingAPIListWorkloadsRequest, options?: RawAxiosRequestConfig) {
        return RebalancingAPIApiFp(this.configuration).rebalancingAPIListWorkloads(requestParameters.organizationId, requestParameters.clusterId, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const RebalancingAPIListRebalancingPlansStatusFilterEnum = {
    REBALANCING_PLAN_STATUS_UNSPECIFIED: 'REBALANCING_PLAN_STATUS_UNSPECIFIED',
    GENERATING: 'GENERATING',
    READY: 'READY',
    EXECUTING: 'EXECUTING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
    PARTIALLY_COMPLETED: 'PARTIALLY_COMPLETED',
    STALE: 'STALE',
    SKIPPED: 'SKIPPED',
    EXPIRED: 'EXPIRED'
} as const;
export type RebalancingAPIListRebalancingPlansStatusFilterEnum = typeof RebalancingAPIListRebalancingPlansStatusFilterEnum[keyof typeof RebalancingAPIListRebalancingPlansStatusFilterEnum];
